import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { DashboardStatsDTO } from '@/features/dashboard/application/dto/DashboardStatsDTO';

interface DashboardStatsStore {
  stats: DashboardStatsDTO | null;
  lastFetched: number | null;
  setStats: (stats: DashboardStatsDTO) => void;
  clearStats: () => void;
}

export const useDashboardStatsStore = create<DashboardStatsStore>()(
  persist(
    (set) => ({
      stats: null,
      lastFetched: null,
      setStats: (stats) =>
        set({
          stats,
          lastFetched: Date.now(),
        }),
      clearStats: () =>
        set({
          stats: null,
          lastFetched: null,
        }),
    }),
    {
      name: 'dashboard-stats-storage',
    }
  )
);
